import Vue from 'vue';


export const EventBus = new Vue();
export const events = {
    auth: {
        signin: 'auth.signin',
        signup: 'auth.signup',
        signout: 'auth.signout',
        notVerified: 'auth.not_verified',
        missingDirectDebit: 'auth.missingDirectDebit'
    },
    survey: {
        error: 'survey.error',
    },
    rewards: {
        payout: 'rewards.payout'
    }
};
